import { $axios } from '~/utils/api'

const END_POINT = 'form'

const getFormMetadata = (formId: string = 'build'): Promise<any> => {
  return $axios.$get(`${END_POINT}?name=${formId}`)
}

export { getFormMetadata }
